import { Component, NgZone, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
import { ImpersonationService } from "../../../../auth/apigee/impersonation.service";
import { LoggerService } from "../../../../common/logging/logger.service";
import { OfficeSelectorService } from "../../../../common/officeSelector/officeSelector.service";
import { BucketsStatusService, BucketsStatusServiceData } from "../../services/bucketStatusKpi/bucketsStatus.service";
import { BucketsStatusDetailService, BucketsStatusDetailServiceData } from "../../services/bucketStatusKpi/bucketsStatusDetail.service";
import { DualSummaryDetailKpiServiceHost } from "../../../../dashboardCommon/components/kpiServiceHostComponent";

export class BucketStatusData {
    public remaining: number;

    constructor(remaining: number) {
        this.remaining = remaining;
    }
}

@Component({
    selector: 'bucket-status-kpi-service-host',
    template: '<ng-content></ng-content>',
    standalone: false
})
export class BucketsStatusKpiServiceHostComponent extends DualSummaryDetailKpiServiceHost<BucketsStatusService, BucketsStatusServiceData, BucketStatusData, BucketsStatusDetailService, BucketsStatusDetailServiceData, BucketsStatusDetailServiceData>
    implements OnDestroy {
    public getClassName() { return "BucketsStatusKpiServiceHostComponent"; }

    private raasSubscription: Subscription;
    private officeSelectorSubscription: Subscription;

    constructor(zone: NgZone, logger: LoggerService, private impersonationService: ImpersonationService, private officeSelectorService: OfficeSelectorService,
        summaryService: BucketsStatusService, detailService: BucketsStatusDetailService) {
        super(zone, logger, summaryService, detailService);
        this.raasSubscription = this.impersonationService.impersonationChanged.subscribe(() => { this.resetSummary(); });
        this.officeSelectorSubscription = this.officeSelectorService.selectedOfficeUpdated.subscribe(() => { this.resetSummary(); });
    }

    protected processSummaryData(data: BucketsStatusServiceData): BucketStatusData {
        return new BucketStatusData(data.remaining);
    }

    protected getDefaultSummaryData(): BucketStatusData {
        let data = new BucketStatusData(0);
        return data;
    }

    protected extractUpdateTime(data: BucketsStatusServiceData): Date {
        return data.updateTimestamp;
    }

    protected processDetailData(data: BucketsStatusDetailServiceData): BucketsStatusDetailServiceData {
        return data;
    }

    protected performDetailAction(): void {
        if (this.detailData) window.open(this.detailData.link, "_blank");
    }

    public ngOnDestroy(): void {
        if (this.raasSubscription) this.raasSubscription.unsubscribe();
        if (this.officeSelectorSubscription) this.officeSelectorSubscription.unsubscribe();
    }
}